import React from 'react';
import Row from 'components/Row';
import { Wrapper } from '../styled';
import { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { Grid } from 'components/Grid';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { GradientBorderBox } from 'components/styled/Box';
import SocialMediaIcon from 'components/Icons/SocialMedias';
import { SocialType } from 'constant/socialAuth';
import Button from 'components/Button';

export const StyledCardWrapper = styled.div<{
    disabled?: boolean;
}>`
    position: relative;
    &::before {
        content: ${({ disabled }) => (disabled ? "'Coming soon'" : "'Live'")};
        padding: 4px 10px;
        font-size: 12px;
        border-radius: 0 10px;
        position: absolute;
        top: 0;
        right: 0;
        background: ${({ theme, disabled }) => (disabled ? theme.c.primary01 : theme.c.success)};
        color: #000;
        z-index: 1;
    }
`;

const StyledCard = styled(GradientBorderBox).attrs((props) => ({
    gradient: `linear-gradient(180deg,  ${props.theme.c.primary01} 0%, ${props.theme.c.primary02} 50%, #000 100%)`,
    borderRadius: 10,
    padding: '40px 20px 20px',
}))<{ disabled?: boolean; flex?: number }>`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    user-select: ${({ disabled }) => (disabled ? 'none' : 'unset')};
    position: relative;
    flex: ${({ flex }) => flex || 1};
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

const BorderedButton = styled(Button).attrs({
    size: 'unset',
    type: 'outlineGradient',
})`
    padding: 8px 20px !important;
    border-radius: 28px !important;
    transition: all 0.3s ease;
    white-space: nowrap;
    width: 100%;
    @media (min-width: 768px) {
        width: auto;
    }

    &:hover {
        transform: translateY(-2px);
    }
`;

const RightSection = styled(Row)`
    gap: 12px;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
`;

const MainText = styled(TYPE.main)`
    flex: 1;
    margin-right: 12px;
    white-space: nowrap;
`;

const Link = styled.a`
    text-decoration: none;
    &:visited {
        color: unset;
    }
`;

const communityData = [
    {
        socialType: SocialType.Twitter,
        title: 'Follow @GOATRollup on X',
        link: 'https://x.com/GOATRollup',
        buttonText: 'Follow',
    },
    {
        socialType: SocialType.TelegramCN,
        title: 'Join our Telegram(CN) Community',
        link: 'https://t.me/GOAT_CN',
        buttonText: 'Join',
    },
    {
        socialType: SocialType.Telegram,
        title: 'Join our Telegram Community',
        link: 'https://t.me/GOATrollup',
        buttonText: 'Join',
    },
    {
        socialType: SocialType.Discord,
        title: 'Join our Discord Community',
        link: 'https://discord.com/invite/goatnetworkofficial',
        buttonText: 'Join',
    }
];

const Community = () => {
    return (
        <Wrapper id="socialProfile" style={{ scrollMarginTop: isMobile ? '100px' : 'unset' }}>
            <Row marginBottom="40px">
                <AutoColumn>
                    <TYPE.main fontSize={24} fontWeight={700} mobileFz={18} marginBottom={'6px'}>
                        Join Our Community
                    </TYPE.main>
                    <TYPE.desc fontSize={14} color="#999">
                        Join our community to receive the latest updates and news.
                    </TYPE.desc>
                </AutoColumn>
            </Row>
            <Grid col={1} gap="20px">
                {communityData.map((item, index) => (
                    <StyledCardWrapper key={item.socialType}>
                        <StyledCard key={index}>
                            <Row gap={isMobile ? '0' : '40px'} align="center" style={{ width: '100%' }}>
                                <SocialMediaIcon type={item.socialType} />
                                <CardContent>
                                    <Row
                                        style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}
                                    >
                                        <Row style={{ width: 'auto' }}>
                                            <MainText fontSize={14}>{item.title}</MainText>
                                        </Row>
                                        {!isMobile && (
                                            <RightSection style={{ width: 'auto' }}>
                                                <Link href={item.link} target="_blank" rel="noreferrer">
                                                    <BorderedButton>{item.buttonText}</BorderedButton>
                                                </Link>
                                            </RightSection>
                                        )}
                                    </Row>
                                </CardContent>
                            </Row>
                            {isMobile ? (
                                <Link href={item.link} target="_blank" rel="noreferrer">
                                    <Row
                                        gap="12px"
                                        align="center"
                                        style={{ width: '100%', justifyContent: 'center' }}
                                        marginTop={12}
                                    >
                                        <BorderedButton>{item.buttonText}</BorderedButton>
                                    </Row>
                                </Link>
                            ) : null}
                        </StyledCard>
                    </StyledCardWrapper>
                ))}
            </Grid>
        </Wrapper>
    );
};

export default Community;
